import LoadingConstants from 'app/shared/constants/LoadingConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

import BillingPaymentSessionInfo from 'app/shared/model/BillingPaymentSessionInfo';

const initState = () => ({
    paymentSessionInfo: new BillingPaymentSessionInfo(),
    paymentSessionInfoLoadingState: LoadingConstants.LOADING,
    displaySuccessMessage: false,
});

const payment = (state = initState(), action = {}) => {
    const { type } = action;

    switch (type) {
        case DispatchConstants.BILLING_SET_PAYMENT_SESSION_INFO:
            return {
                ...state,
                paymentSessionInfo: action.payload.paymentSessionInfo,
                paymentSessionInfoLoadingState: LoadingConstants.SUCCESS,
            };
        case DispatchConstants.BILLING_SET_PAYMENT_SESSION_INFO_STATE:
            return {
                ...state,
                paymentSessionInfoLoadingState: action.payload,
            };
        case DispatchConstants.BILLING_SET_PAYMENT_DISPLAY_SUCCESS:
            return {
                ...state,
                displaySuccessMessage: action.payload.displaySuccessMessage,
            };
        default:
            return state;
    }
};

export default payment;
